import React from "react";
import PM_FS_Logo from "./../../assets/pmfs-tag.svg";

export const PmFoundationStone = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={PM_FS_Logo} />
    </div>
  ) : null;
};
